import { useContext } from 'react';
import { IdentificationChartsDataContext } from '../contexts/IdentificationChartsDataContext';

export const useIdentificationChartsDataContext = () => {
    return useContext(IdentificationChartsDataContext);
};
